module.exports = __webpack_public_path__ + "static/media/orange_animal_amphibians_5.46dbc226.webp";